import { Button } from 'react-native-elements';
import { Linking, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Links } from '@/config/links';
import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Text } from '@/components/Text';
import { appTheme } from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

import { styles } from './styles';

export const Instructions = () => {
  const responsiveFontSize = useResponsiveFontSize(1);
  const rf = (factor: number) => responsiveFontSize * factor;

  const responsiveStyles = StyleSheet.create({
    buttonStyle: {
      marginVertical: rf(1),
      backgroundColor: appTheme.primary,
      maxWidth: 400,
      padding: rf(1),
    },
    buttonTitleStyle: {
      fontSize: IS_WEB ? 16 : rf(1.5),
    },
    textStyle: {
      fontSize: IS_WEB ? 18 : rf(2),
      fontWeight: '700',
    },
  });

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <View style={styles.container}>
        <View style={styles.textButtonWrapper}>
          <Text style={responsiveStyles.textStyle}>
            Die Gebrauchsanweisung für Patient:innen finden Sie hier:
          </Text>
          <Button
            title="Anleitung im Browser öffnen"
            buttonStyle={responsiveStyles.buttonStyle}
            titleStyle={responsiveStyles.buttonTitleStyle}
            onPress={() => Linking.openURL(Links.anleitung.href)}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};
